// @ts-check

import { useCompanyStore } from '@/store/company'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

export const useDemoMode = () => {
  const companyStore = useCompanyStore()

  const { company } = storeToRefs(companyStore)

  const isInDemoMode = computed(() => company.value.is_in_demo_mode)

  /**
   * @template {(...params: unknown[]) => void|Promise<void>} T
   * @param {T} callback
   * @param  {Parameters<T>} params
   * @returns
   */
  const skipInDemoMode = async (callback, ...params) => {
    if (isInDemoMode.value) {
      return
    }
    await callback(...params)
  }

  /**
   * @template {(...params: unknown[]) => void|Promise<void>} T
   * @param {T} callback
   * @param  {Parameters<T>} params
   * @returns
   */
  const runInDemoMode = async (callback, ...params) => {
    if (!isInDemoMode.value) {
      return
    }
    await callback(...params)
  }

  return {
    isInDemoMode,
    skipInDemoMode,
    runInDemoMode
  }
}
